import React from 'react';
import { Card } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';

export default () => {
  const { formatMessage } = useIntl();
  return <Card className="dbd-default-component">
    {formatMessage({ id: 'common_component_update' })}
  </Card>;
};
